/* eslint-disable-next-line import/no-unassigned-import, unicorn/no-unnecessary-polyfills -- polyfill by design */
import 'core-js/actual';
import { createRoot } from 'react-dom/client';
import ReactModal from 'react-modal';

import App from './App';

const app = document.querySelector('#app');
const root = app && createRoot(app);
ReactModal.setAppElement('#app');

// Portal API base for white-label merge (see portal-white-label.ts + SettingsProvider).
// Set window.__PORTAL_API_BASE to your CoreQC API origin in production (CORS must allow the Logto origin).
if (!window.__PORTAL_API_BASE) {
  Reflect.set(window, '__PORTAL_API_BASE', 'http://localhost:3000');
}

root?.render(<App />);
